<template>
  <div class="fill-height"
    :style="[
      {'background-color': `#F4F4F4`} 
    ]"
  >
    <strategio-app-bar></strategio-app-bar>
    <v-main style="height:100vh;padding-top:87px">
      <div style="max-height:100%; overflow:auto">
        <v-container>
          <v-row class="strategio-titles-windows" >
            <v-col cols="5" align-self="center">
              <v-icon  :color="'black'"  style="font-size:52px;padding-bottom: 30px; padding-right: 10px;"
              >ico-icon-star</v-icon>
              <span style="font-size:45px;font-weight:bold;color:black;-webkit-text-stroke: 2px black;">
                Favoritos
              </span>
            </v-col>
          </v-row>

          <v-row class="ma-5 px-5">
    
            <v-col cols="12">
              <report-list-item 
                v-for="f in favorites" 
                :key="f.reportID" 
                :report-data="f"
                favorites-page
              />
            </v-col>
          </v-row>
        </v-container>
      </div>
    </v-main>
    <custom-snack-bar></custom-snack-bar>

  </div>
</template>

<script>
import eventBus from '../utils/eventBus'

import StrategioAppBar from '../components/header-bar/strategio-app-bar.vue'
import ReportListItem from '../components/reports/report-list-item.vue'
import reportsStorage from '../storage/reportsStorage'

import CustomSnackBar from '../components/snackbars/custom-snack-bar.vue'

export default {
  name: 'favorites',
  data () {
    return {
      favorites: []
    }
  },
  mounted () {
    reportsStorage.getData({
      forceLoad: false,
      onSuccess: (data) => {
        const _favorites = []
        console.log(data)
        data.map((item, index) => {
          if (item.isFavorite) {
            _favorites.push(item)
          }
        })
        this.favorites = _favorites
      },
      onError: (error) => {
        let message = 'Error desconocido'
        if (error.response) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          console.log(error.response.data)
          // console.log(error.response.status);
          // console.log(error.response.headers);
        } else if (error.request) {
          // The request was made but no response was received
          // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
          // http.ClientRequest in node.js
          console.log(error.request)
          message = 'No pudimos obtener respuesta del servidor'
        } else {
          // Something happened in setting up the request that triggered an Error
          message = `Error desconocido: ${error.message}`
        }
        eventBus.$emit('open-custom-snack-bar', {message, itsOk: false})
      }
    })
  },
  methods: {
    goBack () {
      this.$router.push('/0')
    }
  },
  components: {
    ReportListItem,
    StrategioAppBar,
    CustomSnackBar
  }
}
</script>
<style scoped>
.strategio-folder-title {
  font-family: 'Nexa-Bold';
  font-style: normal;
  font-weight: 400;
  font-size: 50px;
  line-height: 52px;
  color: #000000;
}
</style>


// WEBPACK FOOTER //
// src/routes/favorites.vue